module.exports = __webpack_public_path__ + "media/character-fish-content.c63cc199.mp3";